import * as React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { ImageSlider } from '../../core/ImageSlider'
import { isPdfFile } from '../../../utils/scaffoldReceiptPdf'

type RequestAttachmentListProps = {
	attachments: File[]
	onDelete: (file: File | undefined) => void
	readOnly?: boolean
}

export default function RequestAttachmentList({
	attachments,
	onDelete,
	readOnly = false,
}: RequestAttachmentListProps) {
	if (attachments.length === 0) return null

	const attachmentImages = attachments.filter((file) => !isPdfFile(file))
	const attachmentPdfs = attachments.filter(isPdfFile)

	return (
		<>
			<Typography
				variant='subtitle1'
				component='h2'
				sx={{
					fontWeight: 600,
					color: 'primary.main',
					mb: 2.5,
					letterSpacing: 0.02,
				}}
			>
				Attachments
			</Typography>

			<Grid container spacing={2.5} sx={{ mb: { xs: 3, sm: 4 } }}>
				<Grid item xs={12}>
					{attachmentImages.length > 0 && (
						<ImageSlider
							blobs={attachmentImages}
							handleDelete={(index) => onDelete(attachmentImages[index])}
							readOnly={readOnly}
						/>
					)}
					{attachmentPdfs.map((file) => (
						<Box
							key={file.name}
							sx={{
								display: 'flex',
								alignItems: 'center',
								mb: 1,
								justifyContent: 'space-between',
							}}
						>
							<Typography variant='body1'>• {file.name}</Typography>
							{!readOnly && (
								<Button variant='contained' color='error' onClick={() => onDelete(file)}>
									<DeleteIcon />
								</Button>
							)}
						</Box>
					))}
				</Grid>
			</Grid>
		</>
	)
}
